// extracted by mini-css-extract-plugin
export default {"controls_container":"PatientDetailsControls_controls_container__CzYy4","copy_text_box":"PatientDetailsControls_copy_text_box__23A6C"};